/**
 * The development chat's shared threads (#75). Asking happens in the chat
 * function, which streams (Chat.tsx); everything else is these API calls.
 */

import type { ChatMessage, ChatThread } from "@baros/core";
import { request } from "./api.js";

export interface OpenChat {
  readonly chat: ChatThread;
  readonly messages: readonly ChatMessage[];
  /** Whether the signed-in person may delete it. */
  readonly mayDelete: boolean;
}

const path = (chatId: string) => `/v1/chats/${encodeURIComponent(chatId)}`;

export const chatApi = {
  list: (token: string) => request<{ chats: readonly ChatThread[] }>(token, "GET", "/v1/chats"),
  open: (token: string, chatId: string) => request<OpenChat>(token, "GET", path(chatId)),
  rename: (token: string, chatId: string, title: string) =>
    request<{ chat: ChatThread }>(token, "PUT", path(chatId), { title }),
  remove: (token: string, chatId: string) =>
    request<{ deleted: string }>(token, "DELETE", path(chatId)),
};
